import { useQuery } from 'data-fetching-client';
import { GET_CRM_OBJECT_PROPERTY } from 'automation-ui-management/queries/crmObjectQueries';
import MissingLabel from 'automation-ui-core/components/MissingLabel';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyNameLabel = ({
  objectTypeId,
  propertyName
}) => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_CRM_OBJECT_PROPERTY, {
    variables: {
      objectTypeId,
      propertyName
    }
  });
  if (loading) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      width: 80
    });
  }
  if (!data || !data.getCrmObjectProperty || !!error) {
    return /*#__PURE__*/_jsx(MissingLabel, {
      type: "property",
      internalName: propertyName
    });
  }
  return /*#__PURE__*/_jsx("span", {
    children: data.getCrmObjectProperty.property.label
  });
};
export default PropertyNameLabel;